
<template>
    <div>menu
    <v-menu
        v-for="menuItem in menuItems"
        open-on-hover
        top
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
            >
                {{ menuItem.title }}
            </v-btn>
        </template>

        <v-list>
            <v-list-item
                v-for="menuItem in menuItem.children"
                :key="index"
            >
                <v-list-item-title>
                    <a :href="menuItem.url">{{ menuItem.title }}</a>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
    </div>
</template>

<script>
export default {
    name: 'HeaderMenu',

    props: {
        menuItems: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
